export default "__VITE_ASSET__bdda4e0a__"